import { AssignmentsDetailPage } from "./Details/AssignmentsDetailPage";
import { AssignmentsListPage } from "./ListPage/AssignmentsListPage";

export const pages = {
  assignments: AssignmentsListPage,
  "assignments.detail": AssignmentsDetailPage,
};
